module.exports = __webpack_public_path__ + "img/bl-big-02.eb8eaeff.jpg";